import { type IContent } from "@kunduz/data-access-cms-api";
import { ReactElement } from "react";
import styles from "./plainText.module.scss";

export const PlanDetailDescriptionPlainText = (props: Props): ReactElement => {
  return (
    <div
      className={styles.description}
      dangerouslySetInnerHTML={{ __html: props.data.text || "" }}
    ></div>
  );
};

interface Props {
  data: IContent.PlanDetailV2AccordionData["items"][0]["items"][0]["data"];
}
